import React from 'react';
import { Box } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { WSR_PAGES, wsrColors, wsrShadow } from './wsrTokens';

interface WsrSideRailProps {
  active: number;
  onChange: (page: number) => void;
}

const WsrSideRail: React.FC<WsrSideRailProps> = ({ active, onChange }) => (
  <Box
    sx={{
      background: '#fff',
      border: `1px solid ${wsrColors.slate200}`,
      borderRadius: '12px',
      padding: '8px',
      position: 'sticky',
      top: 0,
      height: 'fit-content',
      boxShadow: wsrShadow,
    }}
  >
    <Box
      sx={{
        padding: '10px 12px 6px',
        fontSize: 11,
        fontWeight: 600,
        color: wsrColors.slate400,
        textTransform: 'uppercase',
        letterSpacing: '.08em',
      }}
    >
      Sections
    </Box>
    {WSR_PAGES.map((page) => {
      const isActive = active === page.num;
      return (
        <Box
          key={page.num}
          component="button"
          onClick={() => onChange(page.num)}
          sx={{
            width: '100%',
            textAlign: 'left',
            border: 'none',
            background: isActive ? wsrColors.blue50 : 'transparent',
            color: isActive ? wsrColors.blue700 : wsrColors.slate700,
            padding: '10px 12px',
            borderRadius: '8px',
            fontSize: 13,
            fontWeight: isActive ? 600 : 500,
            cursor: 'pointer',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            marginBottom: '2px',
            '&:hover': {
              background: isActive ? wsrColors.blue50 : wsrColors.slate100,
            },
          }}
        >
          <Box
            component="span"
            sx={{
              width: 24,
              height: 24,
              borderRadius: '6px',
              background: isActive ? wsrColors.blue : wsrColors.slate100,
              color: isActive ? '#fff' : wsrColors.slate500,
              fontSize: 11,
              fontWeight: 700,
              display: 'grid',
              placeItems: 'center',
              flexShrink: 0,
            }}
          >
            {page.num}
          </Box>
          <Box component="span" sx={{ flex: 1 }}>
            {page.label}
          </Box>
          {isActive && <ChevronRightIcon sx={{ fontSize: 14 }} />}
        </Box>
      );
    })}
  </Box>
);

export default WsrSideRail;
